import { render, staticRenderFns } from "./addtip.vue?vue&type=template&id=e5b59a16&"
import script from "./addtip.vue?vue&type=script&lang=js&"
export * from "./addtip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports